<div class="panel-body">
	<div class="form-group">
		<span class="dropdown">
			<button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">CHOOSE RECIPIENTS <span class="caret"></span></button>
			<ul class="dropdown-menu" (click)="$event.stopPropagation()">
				<input type="text" [(ngModel)]="mRoleSearchValue" (ngModelChange)="refreshDisplayedRoles()" class="form-control" placeholder="Search for Groups..." style="margin-bottom: 10px">
				<div style="overflow-y: auto; max-height: 300px">
					<div class="table-responsive">
						<table class="table table-hover">
							<thead>
								<tr>
									<th style="width: 10px">
										<div class="checkbox checkbox-inline">
											<input [checked]="isAllDisplayedRolesSelected()" (change)="setAllDisplayedRolesSelected($event.target.checked)" type="checkbox" />
											<label></label>
										</div>
									</th>
									<th (click)="setAllDisplayedRolesSelected(!isAllDisplayedRolesSelected())" style="cursor: pointer;">SELECT ALL</th>
								</tr>
							</thead>
							<tbody>
								<ng-container *ngFor="let role of mDisplayedRoles">
									<tr>
										<td>
											<div class="checkbox checkbox-inline" style="cursor: pointer;">
												<input [checked]="isRoleSelected(role)" (change)="selectRole(role, $event.target.checked)" type="checkbox" class="styled" />
												<label style="cursor: pointer;"></label>
											</div>
										</td>
										<td (click)="selectRole(role, !isRoleSelected(role))" style="cursor: pointer;">
											{{role.name}}
										</td>
									</tr>
								</ng-container>
							</tbody>
						</table>
					</div>
				</div>
			</ul>
		</span>
	</div>
</div>